module.exports = __webpack_public_path__ + "static/media/jenkins.79a09ccb.png";